<template>
	<div id="metaheader">
		<div class="b_banxin">
			<div class="top flex">
				<router-link to="/index" class="toplogo">
					<img src="../assets/img/logo1.png" alt="">
				</router-link>
				<div class="topsearchbox">
					<div class="topsearchboxtop flex">
						<input type="text" placeholder="请输入关键字" class="v_input" v-model="seachValue"/>
						<div class="v_btn el-icon-search" @click="search">
						</div>
					</div>
				</div>
				<div class="topright flex" @click="myshopCar">
					<div class="toprighticobox">
						<img src="../assets/img/gouwucheman.png" alt="" class="toprightico">
						<div class="topiconum" v-if="username != ''">
							{{this.$store.state.shopcarNum}}
						</div>
					</div>
					<div class="toprighttxt">购物车</div>
				</div>
				<div class="topright flex" @click="myPersonal">
					<div class="toprighticobox">
						<img src="../assets/img/menu_iconwodecopy.png" alt="" class="toprightico">
					</div>
					<div class="toprighttxt">个人中心</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import store from  '../store/index.js'
	export default {
		data() {
			return {
				searchval: "",
				username: '',
				personalData: {}, //购物车数量所需数据
				personalData1: 0, //购物车数量
				seachValue: '', //输入的值
			}
		},
		store,
		watch: {
			seachValue() {
				let that = this;

				that.seachValue = that.seachValue;

			},
		},
		created() {
			let that = this;
			//			that.ScrollUp();

			if(that.$storage.get('user_data') != null) {
				that.username = that.$storage.get('user_data').alias;
				that.personalData['user_id'] = that.$storage.get('user_data').user_id;
//				that.personalFn();
				that.add_shopnum();
				
			} else {
				that.username = '';
				that.personalData = {};
			}
			document.onkeydown = function(e) {
				let key = window.event.keyCode;
				if(key == 13) {
					that.search();
				}
			};
		},
		methods: {
			add_shopnum(){
				let that = this;
				
				that.$store.commit('add_shopnum');
//				that.personalData1 = that.$store.state.shopcarNum;
//				console.log(that.$store.state.shopcarNum)
			},
			search() {
				let that = this;
				if(that.seachValue == "") {
					this.$message({
						message: "请输入查询内容",
						type: "warning"
					});
				} else {
					that.$router.push({
						path: "/seemore",
						query: {
							title: that.seachValue
						}
					});
				}
			},
			myPersonal() {
				let that = this;
				if(that.$storage.get('user_data') == null) {
					that.$message({
						message: '请先登录或注册！',
						type: 'warning'
					});
				} else {
					that.$router.push({
						path: "/personalCenter",
						query: {}
					});
				}

			},
			myshopCar() {
				let that = this;
				if(that.$storage.get('user_data') == null) {
					that.$message({
						message: '请先登录或注册！',
						type: 'warning'
					});
				} else {
					that.$router.push({
						path: "/shopcarIndex",
						query: {}
					});
				}

			},
			//获取个人中心基础数据
			personalFn() {
				let that = this;

				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.personalmessage,
						data: qs.stringify(that.personalData),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						if(data.stateCode == 10000) {
							that.personalData1 = data.countGoods

						} else {
							that.personalData1 = 0
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			inputFn(event) {
				let that = this;
				// console.log(event)
				that.seachValue = event.currentTarget.value;
			},
		}
	}
</script>

<style scoped>
	#metaheader {
		background-color: #FFFFFF;
		width: 100%;
		border-bottom: 1px solid #999999;
	}
	
	.toplogo {
		width: 240px;
		display: block;
		margin-left: 20px;
	}
	
	.toplogo img {
		width: 240px;
		display: block;
		object-fit: scale-down;
	}
	
	.topsearchbox {
		margin-left: 60px;
		width: 560px;
		box-sizing: border-box;
		padding-top: 40px;
	}
	
	.topsearchboxtop {
		width: 100%;
		height: 40px;
	}
	
	.el-select .el-input {
		width: 130px;
	}
	
	.input-with-select {
		background-color: #fff;
	}
	
	.v_input {
		width: 500px;
		background-color: #FFFFFF;
		font-size: 14px;
		height: 40px;
		line-height: 40px;
		padding: 0 10px;
		border: 1px solid #dc1e33;
		box-sizing: border-box;
	}
	
	.v_btn {
		width: 60px;
		height: 40px;
		background-color: #dc1e33;
		position: relative;
	}
	
	.v_btn:before {
		content: "\e778";
		color: #ffffff;
		width: 20px;
		height: 20px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 10;
		font-size: 20px;
	}
	
	.topsearchboxbtn {
		height: 60px;
		width: 100%;
	}
	
	.topsearchboxbtnson {
		height: 30px;
		line-height: 30px;
		font-size: 14px;
		color: #666666;
		margin-right: 10px;
	}
	
	.topright {
		width: 160px;
		box-sizing: border-box;
		padding-top: 45px;
		padding-left: 45px;
		cursor: pointer;
	}
	
	.toprighticobox {
		height: 30px;
		width: 30px;
		position: relative;
	}
	
	.toprightico {
		height: 30px;
		width: 30px;
		display: block;
	}
	
	.toprighttxt {
		height: 30px;
		line-height: 30px;
		font-size: 18px;
		color: #666666;
		margin-left: 10px;
		cursor: pointer;
	}
	
	.topiconum {
		max-width: 20px;
		overflow: hidden;
		padding: 2px 6px;
		color: #FFFFFF;
		font-size: 10px;
		position: absolute;
		top: -5px;
		left: 80%;
		background-color: #dc1e33;
		border-radius: 5px;
	}
</style>